import _ from 'underscore';

import { GoogleImportRepository } from '../google-import-repositories';

const getBingAccountsUrlTmpl = '/Customers()/Accounts/Default.GridData';

export class SmartImportRepository extends GoogleImportRepository {
  constructor({ deps }) {
    super({ deps });

    this.newRepositoryEnabled = this.permissions.IsSmartImportV2Enabled;
  }

  // set to new Aid if it's under cid level, which might be multi google import
  // or single google import with a differnt aid other than currentAccount.Id
  setAid(aid) {
    if (aid) {
      this.aid = aid;
    }
  }

  getBingAccounts(top = 5, skip = 0, searchQuery = '') {
    let filter = 'Status ne \'Inactive\' and Status ne \'Deleted\'';
    if (!_.isEmpty(searchQuery)) {
      filter += ` and contains(Name, '${searchQuery}')`;
    }
    const url = this.formatUrl({
      url: getBingAccountsUrlTmpl,
      queryParameters: {
        $top: top,
        $skip: skip,
        $count: true,
        $select: 'Id, Name, Currency, Status',
        $filter: filter,
      },
    });
    return this.odata.post(url, {
      data: {
        gridDataParameters: {},
        isManagementRequest: true,
        accountModes: ['Expert'],
      },
    });
  }
}
